export const calculateTotalAmount = (estimate) => {
    switch (estimate.type) {
        case "data1":
            return (() => {
                const supplyAmount = estimate.data1.reduce((amount, item) => {
                    return (+item.amount || 0) + amount;
                }, 0);

                const discountAmount = estimate.data1.reduce((amount, item) => {
                    return (+item.discountAmount || 0) + amount;
                }, 0);

                const amount = estimate.discountType == "none" ? supplyAmount : discountAmount;

                const vat = amount * 0.1;

                return estimate.vatEnable ? amount + vat : amount;
            })();
        case "data2":
            return (() => {
                const discountEnabled = estimate.discountType == "none" ? false : true;

                const supplyAmount = (() => {
                    var materialPrice = estimate.data2.material.spaces.reduce((amount, space) => {
                        return (
                            +space.rows.reduce((amount, row) => {
                                return (+row.amount || 0) + amount;
                            }, 0) + amount
                        );
                    }, 0);

                    var laborCostsPrice = estimate.data2.laborCosts.artificers.reduce((amount, artificer) => {
                        return (
                            +artificer.rows.reduce((amount, row) => {
                                return (+row.amount || 0) + amount;
                            }, 0) + amount
                        );
                    }, 0);

                    return materialPrice + laborCostsPrice;
                })();

                const discountAmount = (() => {
                    var materialPrice = estimate.data2.material.spaces.reduce((amount, space) => {
                        return (
                            +space.rows.reduce((amount, row) => {
                                return (+row.discountAmount || 0) + amount;
                            }, 0) + amount
                        );
                    }, 0);

                    var laborCostsPrice = estimate.data2.laborCosts.artificers.reduce((amount, artificer) => {
                        return (
                            +artificer.rows.reduce((amount, row) => {
                                return (+row.discountAmount || 0) + amount;
                            }, 0) + amount
                        );
                    }, 0);

                    return materialPrice + laborCostsPrice;
                })();

                const amount = !discountEnabled ? supplyAmount : discountAmount;

                const consulting = (amount * (estimate.consultingRate || 0)) / 100;

                const vat = (+amount + consulting) * 0.1;

                return estimate.vatEnable ? +amount + consulting + vat : +amount + consulting;
            })();
        case "file":
            return estimate.totalAmount;
    }
};
